/** Session key for Mission Control APP_SECRET (never logged). */
export const OPS_SECRET_STORAGE_KEY = 'ops_secret';

/**
 * True if the current address bar includes a non-empty `?secret=` (used once on mount,
 * before {@link consumeOpsSecretFromUrl} strips the query).
 */
export function readUrlHadNonemptySecret() {
  if (typeof window === 'undefined') return false;
  try {
    return (
      (new URLSearchParams(window.location.search).get('secret') || '').trim()
        .length > 0
    );
  } catch {
    return false;
  }
}

/**
 * Read `?secret=` from URL (persist to sessionStorage), strip from address bar, else reuse sessionStorage.
 */
export function consumeOpsSecretFromUrl() {
  if (typeof window === 'undefined') return '';
  try {
    const params = new URLSearchParams(window.location.search);
    const q = (params.get('secret') || '').trim();
    if (q) {
      sessionStorage.setItem(OPS_SECRET_STORAGE_KEY, q);
      window.history.replaceState(
        {},
        document.title,
        `${window.location.pathname}${window.location.hash || ''}`
      );
      return q;
    }
    return (sessionStorage.getItem(OPS_SECRET_STORAGE_KEY) || '').trim();
  } catch {
    return (sessionStorage.getItem(OPS_SECRET_STORAGE_KEY) || '').trim();
  }
}
